import React, { useEffect, useState } from 'react'
import Page from './components/Page'
import Breadcrumbs, { IBreadcrumb } from '../components/Breadcrumbs'
import { addNewWarehouse, updateAllWarehouses, updateWarehousesPagination, useReturnAllWarehouses, useReturnWarehousesPagination } from '../features/warehouses/warehousesSlice'
import WarehousesApp, { IWarehouseModel } from '../features/warehouses/WarehousesApp'
import { useDispatch } from 'react-redux'
import { ISearchParam } from '../features/BaseApp'
import { handleRequestError } from '../services/api'
import TextFieldElement2 from '../components/Fields/TextFieldElement2'
import CardItem from '../components/DataDisplayer/CardItem'
import { IDataDisplayerItemField } from '../components/DataDisplayer/DataDisplayer'
import NotFound from '../components/NotFound'
import ProtectedPage from '../features/router/ProtectedPage'
import OnlyAuthorizedMessage from '../components/OnlyAuthorizedMessage'
import VerifyItem from './components/VerifyItem'

function WarehousesPrivatePage() {

    const dispatch = useDispatch()

    const warehouses = useReturnAllWarehouses()

    const warehousesApp = new WarehousesApp()

    const [loading, setLoading] = useState<boolean>(true)
    const [search, setSearch] = useState<string>("")

    const pagination = useReturnWarehousesPagination()

    /**
     * Breadcrumbs
     */
    const breadcrumbs: IBreadcrumb[] = [
        {
            title: "Home",
            link: "/"
        },
        {
            title: "Warehouses",
        }
    ]

    /**
     * Load warehouses
     */
    const loadWarehouses = (page: number, search: string|null, disablePagination: boolean, addItems?: boolean, searchParams?: ISearchParam[]) => {
        setLoading(true)
        warehousesApp.listOfInstances(page, search, disablePagination, addItems, searchParams)
            .then(response => {

                const { data } = response
                const results: IWarehouseModel[] = data.results

                if (addItems){
                    results.map((singleItem) => dispatch(addNewWarehouse(singleItem)))
                }else{
                    dispatch(updateAllWarehouses([]))
                    dispatch(updateAllWarehouses(results))
                }
                
                dispatch(updateWarehousesPagination({
                    count: data.count,
                    current_page: page,
                    total_pages: data.total_pages
                }))

                setLoading(false)

            })
            .catch(error => {
                handleRequestError(error, dispatch)
                setLoading(false)
            })
    }

    /**
     * Handle seacrh
     */
    const handleSearch = () => loadWarehouses(1, search, false)

    /**
     * Load more items
     */
    const handleLoadMoreItems = () => loadWarehouses(pagination.current_page + 1, "", false, true)

    /**
     * Load warehouses
     */
    useEffect(() => {
        loadWarehouses(1, search, false)
    }, [])

    /**
     * Render items
     */
    const renderItems = () => {

        if (loading){
            return(
                <>
                    <CardItem id={0} fields={[]} rawItem={{}} thumbnail="" loading />
                    <CardItem id={0} fields={[]} rawItem={{}} thumbnail="" loading />
                    <CardItem id={0} fields={[]} rawItem={{}} thumbnail="" loading />
                    <CardItem id={0} fields={[]} rawItem={{}} thumbnail="" loading />
                    <CardItem id={0} fields={[]} rawItem={{}} thumbnail="" loading />
                    <CardItem id={0} fields={[]} rawItem={{}} thumbnail="" loading />
                </>
            )
        }

        if (warehouses.length === 0){
            return <NotFound />
        }

        return warehouses.map((warehouse, index) => {

            let fields: IDataDisplayerItemField[] = [
                {
                    id: "title",
                    type: "title",
                    label: "Title",
                    value: warehouse.title
                },
                {
                    id: "title",
                    type: "text",
                    label: "Location",
                    value: warehouse.location_title,
                    showLabel: true
                }
            ]

            return <CardItem id={warehouse.id} fields={fields} rawItem={warehouse} thumbnail={warehouse.thumbnail} key={index} link={`/warehouses/${warehouse.id}`} />
        })
    }

    return(
        <Page>
            <div className="warehouses-page-container content-section-wrapper page-container-wrapper">
                
                <div className="page-container-head-box">
                    <div className="content-of-page-container-head-box">
                        <h1>Warehouses</h1>

                        <Breadcrumbs breadcrumbs={breadcrumbs} />
                    </div>
                </div>

                <div className="search-box-of-page-container-head-box">
                    <div className="content-of-search-box-of-page-container-head-box">
                        <TextFieldElement2 id="search" data={{ name: "search", value: search }} handleOnChange={(id, value) => setSearch(value)} handleKeyUp={(e) => e.key === "Enter" && handleSearch()} type="TextField" fieldType="search" xs={12} fullWidth label="Search" />
                    </div>
                </div>

                <div className="page-container-items">
                    <div className="content-of-page-container-items">
                        {renderItems()}
                    </div>
                </div>

            </div>
        </Page>
    )
}

/**
 * Public warehouse page
 */
function PublicWarehousesPage() {

    return(
        <Page>
            <VerifyItem />
        </Page>
    )
}

export default function Warehouses(){

    return(
        <ProtectedPage isAdminOnly={false} redirectIfUnauthorized={false} CustomErrorPage={PublicWarehousesPage}>
            <WarehousesPrivatePage />
        </ProtectedPage>
    )
}